import {
  PERSONAL_DETAILS_LOADING,
  PERSONAL_DETAILS_SUCCESS,
  PERSONAL_DETAILS_FAILED,
  SAVE_PERSONAL_DETAILS_LOADING,
  SAVE_PERSONAL_DETAILS_SUCCESS,
  SAVE_PERSONAL_DETAILS_FAILED,
  UPLOAD_FILE_MULTIPART_FAILED,
  UPLOAD_FILE_MULTIPART_LOADING,
  UPLOAD_FILE_MULTIPART_SUCCESS,
  VERIFY_EMAIL_FAILED,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_LOADING,
  VERIFY_COMPLETED_LOADING,
  VERIFY_COMPLETED_SUCCESS,
  VERIFY_COMPLETED_FAILED
} from "../Constants/personalDetailsConstants";

export const personalDetailsReducer = (
  state = { personalDetailsData: [] },
  action
) => {
  switch (action.type) {
    case PERSONAL_DETAILS_LOADING:
      return { loading: true, personalDetailsData: [] };
    case PERSONAL_DETAILS_SUCCESS:
      return { loading: false, personalDetailsData: action.payload };
    case PERSONAL_DETAILS_FAILED:
      return { loading: false, error: action.personalDetailsData };
    default:
      return state;
  }
};

export const savePersonalDetailsReducer = (
  state = { savePersonalDetailsData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_PERSONAL_DETAILS_LOADING:
      return { loading: true, savePersonalDetailsData: [] };
    case SAVE_PERSONAL_DETAILS_SUCCESS:
      return { loading: false, savePersonalDetailsData: action.payload };
    case SAVE_PERSONAL_DETAILS_FAILED:
      return { loading: false, error: action.savePersonalDetailsData };
    default:
      return state;
  }
};

export const saveFileUploadReducer = (
  state = { saveFileUploadData: [] },
  action
) => {
  switch (action.type) {
    case UPLOAD_FILE_MULTIPART_LOADING:
      return { loading: true, saveFileUploadData: [] };
    case UPLOAD_FILE_MULTIPART_SUCCESS:
      return { loading: false, saveFileUploadData: action.payload };
    case UPLOAD_FILE_MULTIPART_FAILED:
      return { loading: false, error: action.saveFileUploadData };
    default:
      return state;
  }
};

export const verifyEmailReducer = (
  state = { verifyEmailData: [] },
  action
) => {
  switch (action.type) {
    case VERIFY_EMAIL_LOADING:
      return { loading: true, verifyEmailData: [] };
    case VERIFY_EMAIL_SUCCESS:
      return { loading: false, verifyEmailData: action.payload };
    case VERIFY_EMAIL_FAILED:
      return { loading: false, error: action.verifyEmailData };
    default:
      return state;
  }
};

export const verifyCompletedReducer = (
  state = { verifyCompletedData: [] },
  action
) => {
  switch (action.type) {
    case VERIFY_COMPLETED_LOADING:
      return { loading: true, verifyCompletedData: [] };
    case VERIFY_COMPLETED_SUCCESS:
      return { loading: false, verifyCompletedData: action.payload };
    case VERIFY_COMPLETED_FAILED:
      return { loading: false, error: action.verifyCompletedData };
    default:
      return state;
  }
};
